import 'moment/locale/nb';

import React from 'react';
import ReactGA from 'react-ga';
import moment from 'moment-timezone';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { ApolloClient } from 'apollo-client';
import {
  InMemoryCache,
  IntrospectionFragmentMatcher
} from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { createUploadLink } from 'apollo-upload-client';
import { onError } from 'apollo-link-error';
import { ApolloLink } from 'apollo-link';
import { ApolloProvider } from 'react-apollo';
import { SnackbarProvider } from 'notistack';
import ConfirmProvider from 'providers/ConfirmProvide';

import { ThemeProvider } from '@material-ui/core/styles';

import rootReducer from 'reducers';

import Widget from 'pages/widget/Widget';

import { URI } from 'config';
import widgetTheme from './widgetTheme';
import { CssBaseline } from '@material-ui/core';

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: {
    __schema: {
      types: [] // no types provided
    }
  }
});

const store = createStore(rootReducer);

const client = new ApolloClient({
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors)
        graphQLErrors.forEach(({ message, locations, path }) => {
          console.log(
            `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
          );
        });
      if (networkError) console.log(`[Network error]: ${networkError}`);
    }),
    createUploadLink({ uri: URI, credentials: 'include' }),
    new HttpLink({
      uri: URI,
      credentials: 'include'
    })
  ]),

  cache: new InMemoryCache({ fragmentMatcher })
});

function WidgetApp({
  ownerId,
  receivedAccommodationId,
  receivedActivityId,
  color,
  logo,
  googleAnalyticsTracking,
  languages,
  privacyPolicy,
  termsAndConditions
}) {
  moment.tz.setDefault('CET');
  moment.locale('en');
  moment.updateLocale('en', {
    week: {
      dow: 1
    }
  });

  ReactGA.initialize(googleAnalyticsTracking);

  const cssVariables = {
    baseUI: {
      color: color
    }
  };

  document.documentElement.style.setProperty('--base-color', color);

  return (
    <ApolloProvider client={client}>
      <Provider store={store}>
        <ThemeProvider theme={{ ...widgetTheme, ...cssVariables }}>
          <CssBaseline />

          <ConfirmProvider>
            <SnackbarProvider
              autoHideDuration={3000}
              maxSnack={1}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }}
            >
              <Widget
                ownerId={ownerId}
                receivedAccommodationId={receivedAccommodationId}
                receivedActivityId={receivedActivityId}
                languages={languages}
                logo={logo}
                privacyPolicy={privacyPolicy}
                termsAndConditions={termsAndConditions}
              />
            </SnackbarProvider>
          </ConfirmProvider>
        </ThemeProvider>
      </Provider>
    </ApolloProvider>
  );
}

export default WidgetApp;
